import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { createBreadcrumbSchema } from '../schema';

const Breadcrumbs = ({ items }) => {
  // Generate schema from items
  const schema = createBreadcrumbSchema(items);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
      <nav
        aria-label="Breadcrumb"
        style={{
          padding: '16px 0',
          fontSize: '14px',
        }}
      >
        <ol
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '8px',
            listStyle: 'none',
            margin: 0,
            padding: 0,
          }}
        >
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <li
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                {index > 0 && (
                  <ChevronRight
                    style={{
                      width: '16px',
                      height: '16px',
                      color: '#9ca3af',
                    }}
                  />
                )}
                {isLast || !item.url ? (
                  <span
                    style={{
                      color: isLast ? '#374151' : '#6b7280',
                      fontWeight: isLast ? '500' : '400',
                    }}
                  >
                    {item.name}
                  </span>
                ) : (
                  <Link
                    to={item.url}
                    style={{
                      color: '#2563eb',
                      textDecoration: 'none',
                    }}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
